import type { DateTime } from 'luxon';

/**
 * Luxon format tokens shared across admin UI.
 * Booking date display matches external-bookings `date-formats.shortMonthDayYear`.
 */
export const SHORT_MONTH_DAY_YEAR = 'LLL d, yyyy';

/** 24-hour time; used for `<input type="time">` values and duration updates. */
export const TIME_24H = 'HH:mm';

/** 12-hour time with AM/PM; used for read-only time display. */
export const TIME_12H = 'h:mm a';

export type HourFormat = 12 | 24;

export function displayTimeFormat(
  hourFormat: HourFormat,
): typeof TIME_24H | typeof TIME_12H {
  return hourFormat === 12 ? TIME_12H : TIME_24H;
}

export function formatTimeOfDay(
  dateTime: DateTime,
  hourFormat: HourFormat,
): string {
  return dateTime.toFormat(displayTimeFormat(hourFormat));
}
